import { render, staticRenderFns } from "./ShapeDividerCustoms.vue?vue&type=template&id=01fbc780"
import script from "./ShapeDividerCustoms.vue?vue&type=script&lang=js"
export * from "./ShapeDividerCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports